import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExamDetails, Instructions, ScheduleQuestionAndOptions, UnlockedQuestionDeadline } from '../models/Exam';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamService } from '../services/exam.service';
import { QuestionserviceService } from '../services/questionservice.service';

import { ProctoringService } from '../services/proctoring.service';
import { UserauthenticationserviceService } from '../services/userauthenticationservice.service';
import { environment } from 'src/environments/environment';
import { Util } from '../interceptors/util';
import { QuestionpagefooterComponent } from '../questionpagefooter/questionpagefooter.component';
import { CurrentUser } from '../models/CurrentUser';
import { OnlineService } from '../services/online.service';
import { LanguageService } from '../services/language.service';
import { Subject, Subscription } from 'rxjs';
import { CalculatorToggleService } from '../services/calculator-toggle.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ExamInstructionToggleService } from '../services/exam-instruction-toggle.service';
import { InstructionsModalComponent } from '../shared/instructions-modal/instructions-modal.component';
import { LoadingService } from '../services/loading.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any
@Component({
  selector: 'app-questionlayout',
  templateUrl: './questionlayout.component.html',
  styleUrls: ['./questionlayout.component.css'],
})
export class QuestionlayoutComponent implements OnInit, OnDestroy {
  options: string[];
  countdown: any;
  scheduleid: number;
  questionno: number;
  previousscheduleid: number;
  onblurfunction;
  onfocusfunction;
  usecalc: boolean = false;
  calcInterval: any;
  calcmode: any;
  private destroyed: boolean = false;
  isCalculatorVisible = false;
  instructions: Instructions = new Instructions();
  webtesthtml: SafeHtml = '';
  companyhtml: SafeHtml = '';
  examhtml: SafeHtml = '';
  isExamInstructionVisible = false;
  showQuestionListView: boolean = false;
  isQuestionGrouped: boolean = false;
  isLastQuestionInsideGroup = false;
  isFirstQuestionInsideGroup = false;

  @ViewChild('quesfooter') private questionFooter: QuestionpagefooterComponent;
  @ViewChild(InstructionsModalComponent) instructionsModalComponent!: InstructionsModalComponent;
  @ViewChild('confirmNavigateModal') confirmNavigateModal: TemplateRef<any>;
  get adminpaused() {
    return this.proctorservice.pauseStatus.adminpaused;
  }
  get proctorpaused() {
    return this.proctorservice.pauseStatus.proctorpaused;
  }
  get pausereason() {
    return this.proctorservice.pauseStatus.pausereason;
  }

  timeleft: number;
  status: string;
  markingerrormessage: string;
  dummyQuestionsForFooter: any[];
  timeSpentInterval: any;
  examid: number;
  loadingSubject = new Subject<boolean>();
  networkFailureSubject = new Subject<boolean>();
  timeElapsedSubscription: Subscription;
  toggleCalculatorSubscription: Subscription;
  toggleExamInstructionSubscription: Subscription;

  // Per-question timer
  questionTimerInterval: any;
  questionTimeRemaining: number = 0;
  lockedQuestions: Set<number> = new Set();
  private pauseStartedAt: number | null = null;

  constructor(
    public questionservice: QuestionserviceService,
    public cbtservice: CbtserviceService,
    public router: Router,
    public activatedroute: ActivatedRoute,
    public examservice: ExamService,
    public toastr: ToastrService,
    private proctorservice: ProctoringService,
    private userauth: UserauthenticationserviceService,
    public util: Util,
    public onlineService: OnlineService,
    private languageService: LanguageService,
    private calculatorToggleService: CalculatorToggleService,
    private examInstructionToggleService: ExamInstructionToggleService,
    public sanitizer: DomSanitizer,
    private loadingService: LoadingService,
    private modalService: NgbModal
  ) {
    this.onlineService.userOffline.subscribe((offline) => {
      if (offline) {
        this.router.navigate(['/logout'], { queryParams: { stayinseb: 1 } });
      }
    });
  }
  get language() {
    return this.languageService.language;
  }
  question: ScheduleQuestionAndOptions = new ScheduleQuestionAndOptions();
  examination: ExamDetails = new ExamDetails();
  questioncount: number;
  //currentoption
  private isLoadingDataLevel: number = 0;
  losscount: number = 0;
  lossactionmsg: string = '';
  user: CurrentUser = new CurrentUser();
  thisurl = location.origin + '/';
  focuslosswarningmessage: string = '';
  lostfocus: boolean = false;
  retrievecountdown: any;

  answersubmissioncheck: any;
  markingnotworking: boolean = false;
  //answersubmissionservercheck: any;
  unpauseinterval: any;
  revalidateuserinterval: any;

  get isLoadingData() {
    return this.isLoadingDataLevel > 0;
  }
  //we are doing setIsLoadingData this way so that different scopes can set loading status without knowing what the parent/child will do
  setIsLoadingData(isLoading: boolean) {
    this.isLoadingDataLevel += isLoading ? 1 : -1;
    //console.trace(`isLoadingDataLevel: ${this.isLoadingDataLevel}`);
    if (this.isLoadingDataLevel < 0) {
      console.warn(`isLoadingDataLevel went below 0`);
      console.trace(`isLoadingDataLevel: ${this.isLoadingDataLevel}`);
      this.isLoadingDataLevel = 0;
      if (!environment.production) {
        this.toastr.error(`isLoadingDataLevel went below 0`);
        throw new Error(`isLoadingDataLevel went below 0`);
      }
    }
  }

  async ngOnInit() {
    this.loadingSubject.subscribe((loading: boolean) => {
      if (loading) { 
        this.loadingService.show();
      } else {
        this.loadingService.hide();
      }
      this.setIsLoadingData(loading);
    });

    this.networkFailureSubject.subscribe((fail: boolean) => {
      this.questionservice.markingnotworking = fail;
    });
    
    this.toggleCalculatorSubscription =
      this.calculatorToggleService.toggleCalculator$.subscribe(() => {
        this.toggleCalculator();
      });

    this.toggleExamInstructionSubscription =
      this.examInstructionToggleService.toggleExamInstuctionModal$.subscribe(() => {
        this.toggleExamInstruction();
      });

    this.proctorservice.pauseStatusUpdated.subscribe(async (data) => {
      await this.retrievePauseStatus();
    })

    this.calcInterval = setInterval(() => {
      this.usecalc = this.util.usecalculator;
      this.calcmode = this.util.calculatormode;
    }, 1000);

    try {
      this.setIsLoadingData(true);
      //calling loadPageData here to make sure we load the examination details
      //this.questionservice.getexam
      this.scheduleid = this.activatedroute.snapshot.queryParams.scheduleid;
      this.examid = this.activatedroute.snapshot.queryParams.examid;

      try {
        this.examination = await this.examservice.getexamwithscheduleid(
          this.scheduleid,
          this.examid
        );

        if (!this.examination.useQuestionTimer) {
          this.timeElapsedSubscription = this.examservice.examTimeElapsed$.subscribe(
            (elapsed) => {
              if (elapsed) {
                this.timeelapsed(elapsed);
              }
            }
          );
        }
      } catch (error) {
        this.cbtservice.showHttpError(error);
        throw error;
      }

      await this.retrievePauseStatus();//we've put this here to ensure that if the exam was to start paused, it is paused, the interface shows that immediately

      await this.loadPageData(this.activatedroute.snapshot.queryParams, true);

      this.dummyQuestionsForFooter = [];
      const allQuestions =
        await this.questionservice.getAllQuestionDataFromStorage(
          this.scheduleid,
          this.examination.liteMode,
          this.examination.useCaptcha,
          this.examid
        );

      if (this.examination.useQuestionTimer) {
        if (this.question?.examQuestion?.questionno) {
          this.enforceLowestUnlockedNavigation('init');
        }
      }

      for (let i = 0; i < this.question.questionCount; i++) {
        //
        //when a question is answered, we don't save it to the encrypted storage
        //so, if the page is refreshed, the question selection data is loaded from storage if it exists
        //that storage hasn't been updated with the "answered" status because we shouldn't have to decrypt and encrypt again for each time the question is answered
        //so to know if the question has been answered, we also need to check if the answer is stored in local storage
        //this problem does not exist if you logout and login again because on logout, the local storage is cleared so everything will be loaded from the server afresh
        //and that will have the correct answered status
        const answered = this.questionservice.isQuestionAnswered(allQuestions.questions[i]);

        this.dummyQuestionsForFooter.push({
          questionno: i + 1,
          answered,
          flagged: allQuestions.questions[i].examQuestion.flagged,
          locked: this.examination.useQuestionTimer ? this.isQuestionLocked(i + 1) : false,
        });
      }

      //this.questionservice.startAnswerSubmission();
      this.user = await this.userauth.getCurrentUser();
      if (!this.user) {
        this.toastr.error(this.language.userSessionNotFound);
        this.router.navigate(['/access/login']);
        return;
      }
      //this.proctorservice.stopProctor();//just in case
      this.urlSubsription();

      if (this.examination.useproctor) {
        //this.proctorservice.setProctorPauseStatus(this.user.username, this.proctorpaused, this.adminpaused, this.pausereason);
        this.proctorservice.username = this.user.username;
        // this.proctorservice.pauseStatus = {
        //   proctorpaused: this.proctorpaused,
        //   adminpaused: this.adminpaused,
        //   pausereason: this.pausereason,
        // };
        this.proctorservice.setProctorPauseStatus();
        this.proctorservice.setCountdownTimer(
          this.user.username,
          this.timeleft
        );
      }
      if (!this.examination.liteMode) {
        let iscountingdown = false;
        this.answersubmissioncheck = setInterval(() => {
          const markingNotWorkingHasChanged =
            this.markingnotworking != this.questionservice.markingnotworking;
          this.markingnotworking = this.questionservice.markingnotworking;
          if (markingNotWorkingHasChanged) {
            this.setIsLoadingData(this.markingnotworking);
          }
          this.markingerrormessage =
            this.language.networkConnectionLost + '...';
          if (this.markingnotworking && !iscountingdown) {
            iscountingdown = true;
            this.onlineService.startCountdown();
          } else if (!this.markingnotworking) {
            iscountingdown = false;
            this.onlineService.reset();
          }
        }, 500);

        //we don't need to keep checking isalive because on the server side, we are ensuring that the user is uploading video when the answer is submitted
        // this.revalidateuserinterval = setInterval(async () => {
        //   //doing this interval to ensure that an invalid candidate can't stay logged in and streaming
        //   const data = await this.userauth.getCurrentUser(true);
        //   if(!data){
        //     this.toastr.error('Invalid session');
        //     this.router.navigate(["/logout"]);
        //   }
        // }, 10 * 1000);

        let notmarkedonserver = this.questionservice
          .getAllQuestionsAnswer()
          .filter((q) => !q.saved)
          .map((x) => x.schedulequestionid);
        if (notmarkedonserver.length == 0) {
          this.questionservice.markingnotworking = false;
        }

        notmarkedonserver.forEach(async (x, index) => {
          let data = this.questionservice.getAnsweredquestion(x);
          data.examid = this.examid;
          this.questionservice.markanswer(data);
          if (index < notmarkedonserver.length - 1) {
            await this.util.sleep(1000); //we don't want to request too many captchas via mark answer with too high a frequency
          }
        });

        this.getInstructions();
      }
    } finally {
      this.setIsLoadingData(false);
    }
    console.log(this.question.questionCount, "question count in layout");
    
    this.activatedroute.queryParams.subscribe(params => {
      this.showQuestionListView = params['view'] === 'list' && this.examination.showQuestionList;
    });
  }

  ngOnDestroy(): void {
    //this.questionservice.endAnswerSubmission();
    this.destroyed = true;
    this.stopQuestionTimer();
    this.examservice.resetExamTime();
    this.examservice.resetQuestionTime();

    if (this.onblurfunction) {
      window.removeEventListener('focus', this.onfocusfunction);
      window.removeEventListener('blur', this.onblurfunction);
    }
    clearInterval(this.retrievecountdown);
    // if (this.answersubmissionservercheck) {
    //   clearInterval(this.answersubmissionservercheck);
    // }
    if (this.answersubmissioncheck) {
      clearInterval(this.answersubmissioncheck);
    }
    this.util.usecalculator = false;
    clearInterval(this.unpauseinterval);
    this.retrievecountdown = null;
    this.unpauseinterval = null;
    clearInterval(this.revalidateuserinterval);
    this.revalidateuserinterval = null;
    clearInterval(this.timeSpentInterval);
    this.timeSpentInterval = null;

    this.timeElapsedSubscription?.unsubscribe();

    if (this.calcInterval) {
      clearInterval(this.calcInterval);
      this.calcInterval = null;
    }

    this.toggleCalculatorSubscription?.unsubscribe();
    this.toggleExamInstructionSubscription?.unsubscribe();
    this.examservice.showExamInstruction(false)
  }

  async ngAfterViewInit() {
    console.log('retrieve status');
    this.retrieveExamStatus();
    if (!this.unpauseinterval /*&& this.examination.useproctor*/) {
      this.unpauseinterval = this.pinterval();
    }
    this.timeSpentInterval = this.pingTimeSpentInterval();
  }

  async retrieveStatus() {
    if (
      this.examination.requireadminstart &&
      !this.examination.examstartedbyadmin
    ) {
      try {
        const data = await this.questionservice.getquestionandoptions(
          1,
          this.examination.liteMode,
          this.examination.useCaptcha,
          this.scheduleid,
          this.examination.examid
        );
        this.dataretrievedmanipulation(data, true);

        if (this.retrievecountdown && this.examination.examstartedbyadmin) {
          clearInterval(this.retrievecountdown);
        }
      } catch (error) {
        this.cbtservice.showHttpError(error);
        throw error;
      }
    }
    // console.log(`exam status ${this.examination.examstartedbyadmin}`);
  }

  retrieveExamStatus() {
    this.retrievecountdown = this.ctdinterval();
  }

  ctdinterval() {
    return setInterval(() => {
      if (!this.examination.examstartedbyadmin) {
        this.retrieveStatus();
      }
    }, 1000 * 2);
  }

  async retrievePauseStatus() {
    if (this.scheduleid) {
      let liteMode = this.examination.liteMode;
      const data: {
        reason: string;
        proctorpaused: boolean;
        adminpaused: boolean;
        tleft: number;
        status: string;
        now: string;
        lockedScheduleQuestions?: number[];
        currentUnlockedQuestionDeadline?: UnlockedQuestionDeadline;
      } = await this.examservice
        .getexampausestatusandtimeleftschedule(
          this.scheduleid,
          liteMode,
          this.examid
        )
        .catch((err) => {
          this.cbtservice.showHttpError(err);
          return;
        });
      if (data) {
        const existingPauseStatus = this.proctorservice.pauseStatus;
        this.proctorservice.pauseStatus = {
          pausereason: data.reason,
          proctorpaused: data.proctorpaused,
          adminpaused: data.adminpaused,
        };
        if (this.examination.useproctor) {

          try {
            if (
              existingPauseStatus.proctorpaused !=
              this.proctorservice.pauseStatus.proctorpaused ||
              existingPauseStatus.adminpaused !=
              this.proctorservice.pauseStatus.adminpaused ||
              existingPauseStatus.pausereason !=
              this.proctorservice.pauseStatus.pausereason
            ) {
              this.proctorservice.setProctorPauseStatus();
            }

            this.proctorservice.setCountdownTimer(
              this.user?.username,
              this.timeleft
            );
          }
          catch (e) {
            console.error(e);
          }
        }

        if (!liteMode) {
          if (data?.tleft !== undefined) {
            this.timeleft = data.tleft;
            if (!this.adminpaused && !this.proctorpaused && !this.examination.useQuestionTimer) {
              this.examservice.updateExamTime(data.tleft);
            }
          }
          this.examservice.updateExamPaused(
            this.adminpaused || this.proctorpaused
          );

          // await this.questionservice.updateQuestionTimeleft(
          //   this.scheduleid,
          //   liteMode,
          //   this.examination.useCaptcha,
          //   data.tleft,
          //   this.examid
          // );

          if (this.examination.useQuestionTimer) {
            this.loadLockedQuestions(data.lockedScheduleQuestions);

            const serverDeadline = data.currentUnlockedQuestionDeadline;
            if (serverDeadline?.qNo > 0 && serverDeadline?.deadline) {

              const deadlineMs = new Date(serverDeadline.deadline).getTime();
              const storageKey = `${this.scheduleid}_qtimer_deadline_${serverDeadline.qNo}`;

              const existingDeadlineStr = localStorage.getItem(storageKey);
              const existingDeadlineMs = existingDeadlineStr ? parseInt(existingDeadlineStr, 10) : null;

              let shouldUpdateTimer = true;

              if (existingDeadlineMs) {
                const diffInSeconds = Math.abs(deadlineMs - existingDeadlineMs) / 1000;

                if (diffInSeconds <= 3) {
                  shouldUpdateTimer = false;
                }
              }

              localStorage.setItem(storageKey, deadlineMs.toString());

              const remaining = Math.floor(
                (deadlineMs - new Date(data.now).getTime()) / 1000
              );
              
              if (shouldUpdateTimer) {
                this.examservice.updateQuestionTime(this.questionTimeRemaining);
                this.questionTimeRemaining = Math.max(0, remaining);
              }

              const currentQno = this.question?.examQuestion?.questionno;

              if (currentQno && currentQno !== serverDeadline.qNo) {
                const nextQno = this.getLowestUnlockedQuestion();

                if (nextQno === -1) {
                  
                  // -1 means all locked; nextQno === qno means only this one was left
                  this.toastr.info(this.language.submittingExam);
                  this.timeelapsed(true);
                } else {
                  this.router.navigate(['/exam/question'], {
                    queryParams: {
                      scheduleid: this.question.examination.scheduleid,
                      questionno: nextQno,
                      examid: this.examid,
                    },
                  });
                }
              }
            }
          }
        }

        this.status = data.status;
      }

      if (!this.adminpaused && !this.proctorpaused) {
        //clearInterval(this.unpauseinterval);
        if (!this.question?.examQuestion?.questionhtml) {
          //means the question was retreived without html most likely because the exam was paused when the question was being retrieved
          //await this.retrieveStatus(this.questionno);
          await this.loadPageData(this.activatedroute.snapshot.queryParams, true);
        }
      }
    }
  }

  pinterval() {
    return setInterval(() => {
      if(this.destroyed){
        clearInterval(this.unpauseinterval)
      }
      else{
        this.retrievePauseStatus();
      }
      // if (this.examination.useproctor) {
      //   this.proctorservice.setProctorPauseStatus(this.user.username, this.proctorpaused, this.adminpaused, this.pausereason);
      // }
    }, 1000 * 15);
  }

  onFocus() {
    clearTimeout(this.countdown);
    //console.log('OnPageVisibilityChange => visible');
    if (this.lostfocus && this.focuslosswarningmessage != '') {
      this.toastr.warning(this.focuslosswarningmessage);
    }
  }
  onBlur() {
    if (this.examination.checkfocusloss && !this.proctorservice.chatopened) {
      let audio = new Audio();
      audio.src = '/assets/beep.mp3';
      audio.loop = false;
      audio.load();
      audio.play();
      // console.log("audio played");
      const mythis = this;
      this.countdown = setTimeout(() => {
        if (!mythis.proctorservice.chatopened) {
          this.setres();
        }
        // if ((this.examination.nooffocusloss - this.losscount) === 1) {
        //   audio.play();
        //   console.log("audio played")
        // }
      }, 1000 * this.examination.durationofloss);
    }
  }
  urlSubsription() {
    this.activatedroute.queryParams.subscribe(async (routeParams) => {
      await this.loadPageData(routeParams, false);
    });

    // console.log(JSON.stringify(this.examination))
    this.cbtservice.getPreviousUrl();
    this.losscount = this.question.focuslosscount;
  }

  private async loadPageData(routeParams: any, updateTimer: boolean) {
    //var tobesaved = this.questionservice.previousquestiondata;
    // console.log("to be saved " + JSON.stringify(tobesaved))
    this.setIsLoadingData(true);
    this.scheduleid = routeParams.scheduleid;

    this.questionno = routeParams.questionno;
    let data: ScheduleQuestionAndOptions;

    try {
      // if (!this.questionservice.nextquestiondata) {
      //   // this.allQuestionData = await this.questionservice.getAllQuestionDataFromStorage(this.scheduleid, this.examination.liteMode, this.examination.useCaptcha);
      //   data = await this.questionservice.getquestionandoptions(this.questionno, this.examination.liteMode, this.examination.useCaptcha, this.scheduleid, this.examination.examid);
      // } else {
      //   data = this.questionservice.nextquestiondata;
      //   // this.isLodingDataLevel=false
      // }

      data = await this.questionservice.getquestionandoptions(
        this.questionno,
        this.examination.liteMode,
        this.examination.useCaptcha,
        this.scheduleid,
        this.examination.examid
      );
      this.dataretrievedmanipulation(data, updateTimer);

      if (this.examination.useQuestionTimer && this.lockedQuestions.size > 0) {
        const qno = data.examQuestion?.questionno;
        if (qno && this.isQuestionLocked(qno)) {
          const lowestUnlocked = this.getLowestUnlockedQuestion();
          if (lowestUnlocked === -1) {
            this.toastr.info(this.language.submittingExam);
            this.router.navigate(['/exam/submit'], {
              queryParams: { scheduleid: this.scheduleid, examid: this.examid },
            });
          } else {
            this.toastr.warning(this.language.questionIsLocked(qno));
            this.router.navigate(['/exam/question'], {
              queryParams: { scheduleid: this.scheduleid, questionno: lowestUnlocked, examid: this.examid },
            });
          }
          return;
        }
      }
    } catch (error) {
      //debugger;
      console.error(error);
      this.cbtservice.showHttpError(error);

      throw error;
    } finally {
      this.setIsLoadingData(false);
    }
    // console.log(JSON.stringify(data) + "is data")
  }

  private async dataretrievedmanipulation(data: ScheduleQuestionAndOptions, updateTimer: boolean) {
    if (data.examination.status && data.examination.status != 'Pending' && data.examination.status != 'InProgress') {
      //debugger;
      this.router.navigate(['/exam/submit'], {
        queryParams: { scheduleid: this.scheduleid, examid: this.examid },
      });
      // window.location.href = `${this.thisurl}exam/submit?scheduleid=${this.scheduleid}`;
    }
    this.examination = data.examination;
    //this.exam = await this.examservice.getexamwithscheduleid(this.scheduleid).toPromise().catch(err => this.toastr.error(err));
    if (this.examination.useproctor) {
      if (
        this.previousscheduleid &&
        this.previousscheduleid != this.scheduleid
      ) {
        await this.proctorservice.stopProctor('Schedule Id Mismatch'); //whenever we move from one exam to another, we have to stop the proctor to ensure another one starts
        if (!environment.production) {
          debugger;
          console.trace('going to exams page');
        }
        this.router.navigate(['/exam/userexams']);
        return;
      }
      // //TODO: ensure the following happens in a timely manner...e.g 10 seconds...use Promise.race()
      // await this.proctorservice.startProctor(this.user.username, this.user.fullname, this.exam.examid, this.exam.examname);
    }
    //this.adminpaused = data.exampaused;
    if (data?.timeleft !== undefined) {
      this.timeleft = data.timeleft;
      if (!this.adminpaused && !this.proctorpaused && !this.examination.useQuestionTimer && updateTimer) {
        this.examservice.updateExamTime(data.timeleft);
      }
    }
    this.examservice.updateExamPaused(this.adminpaused || this.proctorpaused);

    //debugger;
    //this.proctorpaused = data.proctorpaused;
    //if (this.proctorpaused || this.adminpaused) {
    if (!this.unpauseinterval /*&& this.examination.useproctor*/) {
      this.unpauseinterval = this.pinterval();
    }
    //}
    //if (!data.essayexamstatusmessage) {

    if (
      this.examination.checkfocusloss &&
      !this.onblurfunction /* && admintestlogin != "True"*/
    ) {
      this.onblurfunction = this.onBlur.bind(this); //have to do it this way because if i just set the event listener to this.setTileSize, the "this" becomes window
      this.onfocusfunction = this.onFocus.bind(this);
      window.addEventListener('focus', this.onfocusfunction);
      window.addEventListener('blur', this.onblurfunction);
    }
    this.question = data;

    this.isQuestionGrouped = !!data.examQuestion.questionGroupID;

    if (this.isQuestionGrouped) {
      let groupedQuestions = await this.questionservice.getQuestionGroupFromStorage(
        data.examQuestion.questionGroupID,
        this.scheduleid,
        data.examination.liteMode,
        data.examination.useCaptcha,
        data.examination.examid
      );
      let groupScheduleQuestionsId = groupedQuestions?.map(q => q.examQuestion.schedulequestionid);
      //record questionView
      this.questionservice.recordQuestionView(groupScheduleQuestionsId ?? []);
    } else { 
      //record questionView
      this.questionservice.recordQuestionView([this.question.examQuestion.schedulequestionid]);
    }
    // Start per-question timer if applicable
    this.startQuestionTimer();

    //}
    //this.essaystatusmessage = data.essayexamstatusmessage;
    this.util.usecalculator = data.examination.usecalculator;
    this.util.calculatormode = data.examination.calculatormode;
  }

  // --- Per-question timer methods ---

  getEffectiveQuestionDuration(question: any): number {
    const examQuestion = question?.examQuestion;
    
    return examQuestion?.usecustomduration
    ? (examQuestion.duration || 0)
    : (this.examination.defaultQuestionDuration || 0);
  }

  startQuestionTimer(): void {
    this.stopQuestionTimer();
    if (!this.examination.useQuestionTimer) return;

    const qno = this.question?.examQuestion?.questionno;
    if (!qno || this.isQuestionLocked(qno)) return;

    const effectiveDuration = this.getEffectiveQuestionDuration(this.question);
    if (effectiveDuration <= 0) {
      this.examservice.updateQuestionTime(null);
      return;
    }

    const storageKey = `${this.scheduleid}_qtimer_deadline_${qno}`;
    const stored = localStorage.getItem(storageKey);

    let deadlineMs: number;

    if (stored !== null) {
      deadlineMs = parseInt(stored, 10);
    } else {
      // First time on this question — set deadline from now
      deadlineMs = Date.now() + effectiveDuration * 1000;
      localStorage.setItem(storageKey, deadlineMs.toString());
    }

    // Compute remaining immediately on load
    const remaining = Math.floor((deadlineMs - Date.now()) / 1000);

    if (remaining <= 0 && !(this.adminpaused || this.proctorpaused)) {
      this.onQuestionTimeExpired();
      return;
    }

    this.questionTimeRemaining = remaining;
    this.examservice.updateQuestionTime(this.questionTimeRemaining);

    this.questionTimerInterval = setInterval(() => {
      if (this.adminpaused || this.proctorpaused) return;

      const remaining = Math.floor((deadlineMs - Date.now()) / 1000);
      this.questionTimeRemaining = remaining;
      this.examservice.updateQuestionTime(remaining);

      if (remaining <= 0) {
        this.onQuestionTimeExpired();
      }
    }, 1000);
  }

  get questionTimerPercent(): number {
    if (!this.examination?.useQuestionTimer) return 100;
    const effectiveDuration = this.getEffectiveQuestionDuration(this.question);
    if (effectiveDuration <= 0) return 100;
    return Math.round((Math.max(0, this.questionTimeRemaining) / effectiveDuration) * 100);
  }

  stopQuestionTimer(): void {
    if (this.questionTimerInterval) {
      clearInterval(this.questionTimerInterval);
      this.questionTimerInterval = null;
    }
  }

  onQuestionTimeExpired(): void {
    this.stopQuestionTimer();
    const qno = this.question?.examQuestion?.questionno;
    if (!qno) return;

    localStorage.removeItem(`${this.scheduleid}_qtimer_deadline_${qno}`);
    this.lockedQuestions.add(qno);
    this.saveLockedQuestions();

    this.questionservice.lockScheduleQuestion(
      this.question.examQuestion.schedulequestionid,
      this.question.examination.scheduleid,
      this.examid,
      this.question.examQuestion.attempt,
      this.question.examQuestion.questionno,
      true
    );

    this.examservice.notifyQuestionTimerExpired(qno);
    this.toastr.warning(this.language.timeElapsedForQuestion(qno));

    // Auto-save current answer
    this.getoptions();
    this.questionservice.constructAnswerSaveData(
      this.question.examQuestion.schedulequestionid,
      this.question.examination.scheduleid,
      this.options,
      this.questionservice.isEssayQuestion(this.question),
      this.examid,
      this.questionservice.isSaqQuestion(this.question),
      this.question.examQuestion.saqanswer
    );

    // Update footer locked styling
    if (this.dummyQuestionsForFooter) {
      const footerQ = this.dummyQuestionsForFooter.find(q => q.questionno === qno);
      if (footerQ) footerQ.locked = true;
    }

    const nextQno = this.getLowestUnlockedQuestion();

    if (nextQno === -1) {
      // -1 means all locked; nextQno === qno means only this one was left
      this.toastr.info(this.language.submittingExam);
      this.timeelapsed(true);
    } else {
      this.router.navigate(['/exam/question'], {
        queryParams: {
          scheduleid: this.question.examination.scheduleid,
          questionno: nextQno,
          examid: this.examid,
        },
      });
    }
  }

  loadLockedQuestions(serverLocked: number[] = []): void {
    const key = `${this.scheduleid}_${this.question?.examQuestion?.attempt}_locked_questions`;
    
    let localSet = new Set<number>();
    
    const stored = localStorage.getItem(key);
    
    if (stored) {
      try {
        const arr: number[] = JSON.parse(stored);
        localSet = new Set(arr);
      } catch {
        localSet = new Set();
      }
    }
    
    if (serverLocked?.length) {
      for (const id of serverLocked) {
        localSet.add(id);
      }
    }
    
    this.lockedQuestions = localSet;

    this.saveLockedQuestions();
  }

  saveLockedQuestions(): void {
    localStorage.setItem(
      `${this.scheduleid}_${this.question?.examQuestion?.attempt}_locked_questions`,
      JSON.stringify([...this.lockedQuestions])
    );
  }

  isQuestionLocked(qNo: number): boolean {
    return this.lockedQuestions.has(qNo);
  }

  getoptions(scheduleid = this.question.examQuestion.schedulequestionid) {
    this.options = [];
    var ele = document.getElementsByClassName(scheduleid.toString());
    for (var i = 0; i < ele.length; i++) {
      this.getchecked(ele[i]);
    }
  }
  getchecked(element) {
    if (element.checked) {
      this.options.push(element.value.toString());
    }
  }

  scrollToQuestion(questionNo: number) {
     this.questionFooter.scrollToQuestion(questionNo);
  }

  async nextqclick(qno: number) {
    if (this.isQuestionGrouped) {
      var groupedQuestions = await this.questionservice.getQuestionGroupFromStorageLite(
      this.question.examQuestion.questionGroupID,
      this.scheduleid,
      this.question.examination.liteMode,
      this.question.examination.useCaptcha,
      this.question.examination.examid);
    
      const lastQuestionInGroup = groupedQuestions.reduce((max, q) =>
        q.examQuestion.questionno > max ? q.examQuestion.questionno : max, 0);
      
      if (lastQuestionInGroup === this.question.questionCount) {
        return;
      }
      await this.qnoclicked(lastQuestionInGroup + 1);
    } else {
      await this.qnoclicked(qno);
    }
  }
  
  async previousqclick(qno: number) {
    if (this.isQuestionGrouped) {
      var groupedQuestions = await this.questionservice.getQuestionGroupFromStorageLite(
      this.question.examQuestion.questionGroupID,
      this.scheduleid,
      this.question.examination.liteMode,
      this.question.examination.useCaptcha,
      this.question.examination.examid);
      
      const firstQuestionInGroup = groupedQuestions.reduce((min, q) =>
        q.examQuestion.questionno < min ? q.examQuestion.questionno : min, Infinity);
      
      if (firstQuestionInGroup === 0) {
        return;
      }
      
      await this.qnoclicked(firstQuestionInGroup - 1);
    } else {
      await this.qnoclicked(qno);
    }
  }

  async qnoclicked(qno: number) {
    if (this.examination.useQuestionTimer) {
      if (!this.enforceLowestUnlockedNavigation('click')) return;

      const currentQno = this.question?.examQuestion?.questionno;
      const lowestUnlocked = this.getLowestUnlockedQuestion(currentQno);
      if (this.isQuestionLocked(qno)) {
        this.toastr.warning(this.language.questionAlreadyAttempted(qno));
        return;
      }
      if (qno !== lowestUnlocked) {
        this.toastr.warning(
          this.isQuestionLocked(qno)
            ? this.language.questionAlreadyAttempted(qno)
            : this.language.mustAttemptQuestionFirst(lowestUnlocked)
        );
        return;
      }

      const isForwardNavigation = this.examination.useQuestionTimer && currentQno && qno > currentQno;

      // If question timer is on and navigating forward, check if question is answered
      if (isForwardNavigation) {
        const isAnswered = this.isCurrentQuestionAnswered();
        if (!isAnswered) {
          // Show confirmation modal
          const confirmed = await this.showConfirmNavigateModal();
          if (!confirmed) return;
        }
      }

      this.stopQuestionTimer();

      // Lock the current question when navigating forward (no going back)
      if (isForwardNavigation && currentQno) {
        localStorage.removeItem(`${this.scheduleid}_qtimer_deadline_${currentQno}`);
        this.lockedQuestions.add(currentQno);
        this.saveLockedQuestions();
        if (this.dummyQuestionsForFooter) {
          const footerQ = this.dummyQuestionsForFooter.find(q => q.questionno === currentQno);
          if (footerQ) footerQ.locked = true;
        }

        this.questionservice.lockScheduleQuestion(
          this.question.examQuestion.schedulequestionid,
          this.question.examination.scheduleid,
          this.examid,
          this.question.examQuestion.attempt,
          this.question.examQuestion.questionno,
          false
        );
      }
    }
    
    this.setIsLoadingData(true);

    try {
      this.getoptions();

      const data = this.questionservice.constructAnswerSaveData(
        this.question.examQuestion.schedulequestionid,
        this.question.examination.scheduleid,
        this.options,
        this.questionservice.isEssayQuestion(this.question),
        this.examid,
        this.questionservice.isSaqQuestion(this.question),
        this.question.examQuestion.saqanswer
      );

      try {
        const data = await this.questionservice.getquestionandoptions(
          qno,
          this.examination.liteMode,
          this.examination.useCaptcha,
          this.scheduleid,
          this.examination.examid
        );
        this.router.navigate(['/exam/question'], {
          queryParams: {
            scheduleid: this.question.examination.scheduleid,
            questionno: qno,
            examid: this.examid,
          },
        });
        
        this.questionFooter.scrollToQuestion(qno);
      } catch (error) {
        this.cbtservice.showHttpError(error);
        throw error;
      }
    } finally {
      this.setIsLoadingData(false);
    }
  }

  isCurrentQuestionAnswered(): boolean {
    if (!this.question?.examQuestion?.schedulequestionid) return false;
    if (this.questionservice.isMcqQuestion(this.question)) {
      this.getoptions();
      if (this.options && this.options.length > 0) return true;
    }
    return this.questionservice.isQuestionAnswered(this.question);
  }

  showConfirmNavigateModal(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const modalRef = this.modalService.open(this.confirmNavigateModal, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        size: 'sm'
      });
      modalRef.result.then(
        () => resolve(true),   // confirmed
        () => resolve(false)   // dismissed
      );
    });
  }

  quesanswered(qno: number) {
    // console.log('Hey '+qno);
    this.questionFooter.answerQuestion(qno);
    if (!this.unpauseinterval && this.examination.useproctor)
      this.unpauseinterval = this.pinterval();
  }
  quesunanswered(qno: number) {
    //console.log('Hey '+qno);
    this.questionFooter.unanswerQuestion(qno);
    if (!this.unpauseinterval && this.examination.useproctor)
      this.unpauseinterval = this.pinterval();
  }
  quesflagged(data: any) {
    this.questionFooter.flagquestion(data);
  }

  async setres() {
    var data: any = await this.examservice
      .setfocuslosscounter(this.scheduleid, this.examid)
      .catch((err) => this.cbtservice.showHttpError(err));
    this.losscount = data.flcount;
    clearTimeout(this.countdown);
    if (this.losscount > this.examination.nooffocusloss) {
      var data2: any = await this.examservice
        .performfocuslossaction(this.scheduleid, this.examid)
        .catch((err) => this.cbtservice.showHttpError(err));

      //debugger;

      if (
        data2.msg == 'ReduceTIme' &&
        this.examination.focuspenalty == 'ReduceTIme'
      ) {
        this.toastr.warning(
          `${this.language.youHaveLost} ${this.examination.reducetimelossduration} ${this.language.leavingExamPage}`
        );
      }
      if (/*data2.msg &&*/ data2.msg != 'ReduceTIme') {
        //debugger;
        // window.location.href = `${this.thisurl}exam/submit?scheduleid=${this.scheduleid}`;
        this.router.navigate(['/exam/submit'], {
          queryParams: { scheduleid: this.scheduleid, examid: this.examid },
        });
      }
    } else {
      this.focuslosswarningmessage = this.language.penalizedWarning;
      this.lostfocus = true;
      this.toastr.warning(this.focuslosswarningmessage);
    }
  }

  async pingTimeSpentInterval() {
    const pingTimeSec = 30;
    return setInterval(async () => {
      if (this.destroyed) {
        // if the user starts exams and leaves the page before 30seconds(Logout), we should stop the API call
        clearInterval(this.timeSpentInterval);
        return;
      }
      try {
        await this.examservice.pingandupdateTimeSpent(
          this.scheduleid,
          this.examid
        );
      }
      catch (error) {
        this.toastr.warning('Unstable Network conditions', null, { timeOut: 2000 });
      }
    }, 1000 * pingTimeSec);
  }

  async flagQuestionForReview() {
    this.question.examQuestion.flagged = !this.question.examQuestion.flagged;

    this.quesflagged({
      qno: this.question.examQuestion.questionno,
      flagged: this.question.examQuestion.flagged,
    });

    this.toastr.success(
      `${this.language.questionHasBeen}  ${this.question.examQuestion.flagged
        ? this.language.flagged
        : this.language.unflagged
      }`
    );
  }

  async timeelapsed(elapsed: boolean) {
    if (elapsed) {
      let answers = [];
      if (this.question.examination.liteMode) {
        answers = this.questionservice.getAllQuestionsAnswer();
      }
      //wait for 2 seconds to ensure that the candidate is really out of time
      await this.util.sleep(2000);
      let retryAttempt = 0;
      const baseRetryDelayMs = 1000;
      const maxRetryDelayMs = 30000;
      let done = false;
      do {
        try {
          this.setIsLoadingData(true);
          const response: any = await this.examservice.submit(
            this.scheduleid,
            elapsed,
            this.question.examination.examid
          );

          if (response && response.statusmsg && response.statusmsg != '') {
            localStorage.clear();
            this.router.navigate(['/exam/submit'], {
              queryParams: {
                scheduleid: this.scheduleid,
                examid: this.question.examination.examid,
              },
            });
          } else if (response && response.statusmsg == ''){
            self.location.reload();
          }
          done = true;
          break;
        } catch (error) {
          console.error(error);
        } finally {
          if(done){
            this.setIsLoadingData(false);
          }
          else{
            retryAttempt++;
            const exponentialDelay = Math.min(
              Math.pow(2, retryAttempt - 1) * baseRetryDelayMs,
              maxRetryDelayMs
            );
            const jitter = Math.floor(Math.random() * 1000);
            await this.util.sleep(exponentialDelay + jitter);
          }
        }
      } while (true);
    }
  }

  toggleCalculator() {
    this.isCalculatorVisible = !this.isCalculatorVisible;
  }

  async getInstructions() {
    try {
      this.instructions = await this.examservice.getInstructions(this.examid);
      let hasInstruction = false;
      if (this.instructions.webtestHTML) {
        this.webtesthtml = this.sanitizer.bypassSecurityTrustHtml(
          this.instructions.webtestHTML
        );
        hasInstruction = true;
      }
      if (this.instructions.companyHTML) {
        this.companyhtml = this.sanitizer.bypassSecurityTrustHtml(
          this.instructions.companyHTML
        );
        hasInstruction = true;
      }
      if (this.instructions.examHTML) {
        this.examhtml = this.sanitizer.bypassSecurityTrustHtml(
          this.instructions.examHTML
        );
        hasInstruction = true;
      }
      if (hasInstruction) {
        this.examservice.showExamInstruction(true)
      } else {
        this.examservice.showExamInstruction(false)
      }
    } catch (error) {
      console.error('Failed to load exam instructions:', error);
      throw error;
    }
  }

  toggleExamInstruction() {
    if (this.instructionsModalComponent) {
      this.instructionsModalComponent.openModal();
    }
  }

  toggleQuestionList() {
    this.showQuestionListView = !this.showQuestionListView;

    const currentParams = { ...this.activatedroute.snapshot.queryParams };

    if (this.showQuestionListView) {
      // Add 'view=list' when showing question list
      currentParams['view'] = 'list';
    } else {
      // Remove 'view' param when showing question view
      delete currentParams['view'];
    }

    this.router.navigate([], {
      relativeTo: this.activatedroute,
      queryParams: currentParams
    });
  }

  async navigateToQuestion(questionNo: number) {
    this.showQuestionListView = false;
    await this.qnoclicked(questionNo);
  }

  getExamDataForQuestionList() {
    return {
      useCaptcha: this.examination.useCaptcha,
      durationofloss: this.examination.durationofloss,
      checkfocusloss: this.examination.checkfocusloss,
      examid: this.examination.examid,
      liteMode: this.examination.liteMode,
      examtype: this.examination.examtype,
      showQuestionList: this.examination.showQuestionList,
      answerData: this.dummyQuestionsForFooter
    };
  }
  
  handleLastQuestion(value: boolean) {
    this.isLastQuestionInsideGroup = value;
  }

  handleFirstQuestion(value: boolean) {
    this.isFirstQuestionInsideGroup = value;
  }

  handleActiveGroupQuestion(questionNo: number) {
    if (!this.question?.examQuestion)
      return;
    
    if (this.question.examQuestion.questionno === questionNo) 
      return;
    
    this.question.examQuestion.questionno = questionNo;
    this.questionFooter?.scrollToQuestion(questionNo);
  }
  
  getPauseKey(): string {
    return `${this.scheduleid}_pauseStartedAt`;
  }

  getLowestUnlockedQuestion(excludeQno?: number): number {
    for (let i = 1; i <= this.question.questionCount; i++) {
      if (i === excludeQno) continue;
      if (!this.isQuestionLocked(i)) return i;
    }
    return -1;
  }

  enforceLowestUnlockedNavigation(context: 'init' | 'click' = 'click'): boolean {
    const lowestUnlocked = this.getLowestUnlockedQuestion();

    if (lowestUnlocked === -1) {
      this.toastr.info(this.language.submitting);
      this.router.navigate(['/exam/submit'], {
        queryParams: { scheduleid: this.scheduleid, examid: this.examid },
      });
      return false;
    }

    const currentQno = this.question?.examQuestion?.questionno;

    if (context === 'init' && lowestUnlocked !== currentQno) {
      const reason = this.isQuestionLocked(currentQno)
        ? this.language.questionAlreadyLocked(currentQno)
        : this.language.questionAlreadyLocked(lowestUnlocked);
      this.toastr.warning(`${reason} ${this.language.redirecting}`);
      this.router.navigate(['/exam/question'], {
        queryParams: {
          scheduleid: this.scheduleid,
          questionno: lowestUnlocked,
          examid: this.examid,
        },
      });
      return false;
    }

    return true;
  }

  get questionTimerClass(): string {
    const p = this.questionTimerPercent;
    if (p > 50) return 'qtimer-high';
    if (p > 20) return 'qtimer-mid';
    return 'qtimer-low';
  }
}
